import { jsxs as _jsxs } from "react/jsx-runtime";
import useDeviceWidth from '../../../hooks/use-device-width';
import { StyledText } from '../../../styles/text';
import { colors } from '../../../styles/theme';
var Description = function (_a) {
    var _b = _a.description, description = _b === void 0 ? '' : _b, _c = _a.hasError, hasError = _c === void 0 ? false : _c, _d = _a.errorMessage, errorMessage = _d === void 0 ? '' : _d, children = _a.children;
    var descriptionMessage = hasError ? errorMessage : description;
    var isMobile = useDeviceWidth();
    return (_jsxs(StyledText, { size: isMobile ? 'regular' : 'root', color: hasError ? colors.terracotta : undefined, children: [descriptionMessage, children] }));
};
export default Description;
//# sourceMappingURL=index.js.map